import swiper from "swiper";



//スライダー
var slider = new swiper('.top-business-slide__inner', {
  loop: true,
  speed: 1000,
  autoplay: {
    delay: 4000,
  },
 spaceBetween: 20,
  navigation: {
    nextEl: '.swiper-button-next',
    prevEl: '.swiper-button-prev',
  },
  pagination: {
    el: ".swiper-pagination",
    clickable: true
  },
  breakpoints: {
    1300: {
      spaceBetween: 30
    },
  }
  // scrollbar: {
  //   el: '.swiper-scrollbar',
  //   draggable: true,
  // },

});
